import React from 'react';
import PropTypes from 'prop-types';
import PriceRangeInput from './PriceRangeInput';

function PriceRangeMin({ value, onChange, disabled, currency }) {
    const placeholder = currency ? `Price Range Min (${currency})` : 'Price Range Min';
    return (
        <PriceRangeInput
            value={value}
            onChange={onChange}
            disabled={disabled}
            placeholder={placeholder}
        />
    );
}

PriceRangeMin.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
    currency: PropTypes.string
};

export default PriceRangeMin;



// WEBPACK FOOTER //
// ./src/js/modules/PriceRangeFilter/components/PriceRangeMin.js